// Decided from the hostname at runtime, so a staging build can't lose the banner by missing a build-time variable.
export function isStagingHost(hostname: string) {
  return /(^|-)staging\./.test(hostname);
}

// Staging shares its database with production, so it must never be mistaken for the real app.
export default function StagingBanner() {
  if (!isStagingHost(window.location.hostname)) return null;

  return (
    <div role="status" className="fixed inset-0 z-[1000] pointer-events-none border-4 border-red-600">
      <span className="absolute bottom-0 left-0 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-tr-lg">
        STAGING – testmiljö, delar databas med produktion
      </span>
    </div>
  );
}
